import { LoaderCircleIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

/**
 * Yuklanish holati — `Suspense` fallback'i sifatida ishlatiladi.
 * `className` orqali balandligini sahifa ichiga moslash mumkin.
 */
export const PageLoader = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-label={t("COMMON.LOADING")}
      className={cn(
        "bg-background flex min-h-screen w-full items-center justify-center",
        className,
      )}
    >
      <LoaderCircleIcon className="text-primary size-8 animate-spin" />
    </div>
  );
};
